import { render, staticRenderFns } from "./Thread.vue?vue&type=template&id=61ba11f6&scoped=true&"
import script from "./Thread.vue?vue&type=script&lang=js&"
export * from "./Thread.vue?vue&type=script&lang=js&"
import style0 from "./Thread.vue?vue&type=style&index=0&id=61ba11f6&prod&lang=scss&"
import style1 from "./Thread.vue?vue&type=style&index=1&id=61ba11f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba11f6",
  null
  
)

export default component.exports